<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Edit Creditor" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="edit()" ngNativeValidate>
          <app-creditor-form [creditor]="creditor" *ngIf="creditor"></app-creditor-form>
        </form>
      </div>
    </section>
  </div>
</div>
